import gql from 'graphql-tag';

export const FETCH_PHARMACY_EMAIL_LOGS = gql`
    query fetchPharmacyEmailLogs($pharmacyId: Int!, $emailId: String!, $limit: Int, $skip: Int){
        fetchPharmacyEmailLogs(pharmacyId: $pharmacyId, emailId: $emailId, limit: $limit, skip: $skip) {
            emailLogs {
                id
                email
                email_type
                email_subject
                email_date
                file_name
                is_seen
            }
        }
    }
`;

export const GET_PHARMACY_EMAIL_LOG_FILE = gql`
    query getPharmacyEmailLogFile($id: Int!, $pharmacy_id: Int!){
        getPharmacyEmailLogFile(id: $id, pharmacy_id: $pharmacy_id){
            file_url,
            file_content,
        }
    }
`;

export const UPDATE_EMAIL_LOG_SEEN_STATUS = gql`
  mutation updateEmailLogSeenStatus($logId: Int!, $isSeen: Boolean!) {
    updateEmailLogSeenStatus(logId: $logId, isSeen: $isSeen) {
      success
      message
    }
  }
`;